import getReadingTime from './getReadingTime';

export const parseArticleLong = node => ({
  heading: node.seo?.title || node.shortHeading || node.heading,
  category: node?.category?.shortHeading || node?.category?.heading,
  date: node.createdAt,
  datetime: node.rawDate,
  readingTime: node.content?.content && `${node.content.content && getReadingTime(node.content.content)}`,
  href: `/${node?.category?.slug}/${node.slug}`,
  isNew: true,
  description: node.shortContent,
  text: node.shortContent,
  picture: {
    src: node.thumbnailImage && node.thumbnailImage.url ? node.thumbnailImage.url : false,
    alt: node.heading
  }
});

export const parseArticleShort = node => ({
  date: node.shortDate,
  datetime: node.rawDate,
  heading: node.seo?.title || node.shortHeading || node.heading,
  href: `/${node?.category?.slug}/${node.slug}`
});

export const parseRankingTile = node => ({
  heading: node.heading,
  category: node?.category?.shortHeading || node?.category?.heading,
  date: node.createdAt,
  datetime: node.rawDate,
  readingTime: node.content?.content && `${node.content.content && getReadingTime(node.content.content)}`,
  href: `/${node?.category?.slug}/${node.slug}`,
  isNew: true,
  description: node.shortContent,
  text: node.shortContent,
  picture: {
    src: node.thumbnailImage && node.thumbnailImage.url ? node.thumbnailImage.url : false,
    alt: node.heading
  }
});
